import { render, staticRenderFns } from "./FormCreateStakeholder.vue?vue&type=template&id=65c71c4a&"
import script from "./FormCreateStakeholder.vue?vue&type=script&lang=js&"
export * from "./FormCreateStakeholder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports